// Mirrors Astra-Backend utils/attachmentPolicy.js. The server enforces both
// rules too; this exists so the user hears about it before the upload starts.
// 2026-09-22 — the owner confirmed the list and chose to accept image/heic and
// image/heif as a fallback for when the mobile client's phone-side HEIC→JPEG
// conversion fails, then extended that the same day to image/heic-sequence and
// image/heif-sequence so Live Photos and burst shots are covered by the same
// fallback. That conversion stays and is still the preferred path.
export const MAX_BYTES = 26214400;
export const ACCEPTED_TYPES = new Set([
  "application/pdf",
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
  "image/heic",
  "image/heif",
  "image/heic-sequence",
  "image/heif-sequence",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/csv",
  "text/plain",
]);
export const ACCEPT_ATTR = [...ACCEPTED_TYPES].join(",");

// Same normalisation as the backend's isAcceptedType: a browser may report a
// media type with parameters and in any case (`text/plain; charset=utf-8`), and
// a bare `ACCEPTED_TYPES.has(file.type)` would refuse client-side a file the
// server then accepts.
const normalizeType = (mime) =>
  String(mime || "")
    .toLowerCase()
    .split(";")[0]
    .trim();

export function validateFiles(files) {
  const ok = [];
  const rejected = [];
  for (const file of files) {
    if (file.size > MAX_BYTES)
      rejected.push({ file, reason: "File size should be 25MB Max." });
    else if (!ACCEPTED_TYPES.has(normalizeType(file.type)))
      rejected.push({ file, reason: "Unsupported file type" });
    else ok.push(file);
  }
  return { ok, rejected };
}
